import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tag as BaseTag } from 'antd';

import type { TagType } from '@app/components/TagsSelect/types';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export const Tag: TagType = ({
  label,
  onClose,
  closable,
  icon,
  backgroundColor,
  color,
  testId,
  className,
}) => {
  return (
    <BaseTag
      color={color}
      onClose={onClose}
      closable={closable}
      icon={
        <FontAwesomeIcon
          icon={icon as IconProp}
          style={{ color, marginRight: '4px' }}
        />
      }
      style={{ color, backgroundColor, borderColor: backgroundColor }}
      closeIcon={<CloseOutlined color={color} style={{ color }} />}
      {...(testId && { 'data-testid': testId })}
      className={className}
    >
      {label}
    </BaseTag>
  );
};
